import { render } from "./ControUsers.vue?vue&type=template&id=58ba824f&scoped=true"
import script from "./ControUsers.vue?vue&type=script&lang=js"
export * from "./ControUsers.vue?vue&type=script&lang=js"

import "./ControUsers.vue?vue&type=style&index=0&id=58ba824f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ba824f"]])

export default __exports__